import React from 'react';

import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import CheckAccess from 'common/components/CheckAccess';

import MenuOption from './MenuOption';
import StyledList from './StyledComponents/StyledList';
import StyledListSubheader from './StyledComponents/StyledListSubheader';

const SubMenuOptions = ({ handleClose, options, title }) => {
    const { pathname } = useLocation();

    const onClick = () => handleClose();

    if (!Array.isArray(options) || options.length === 0) return null;

    const permissions = options.map((option) => option.permission).flat();

    return (
        <CheckAccess requiredPermissions={permissions}>
            <StyledList
                subheader={<StyledListSubheader>{title}</StyledListSubheader>}
            >
                {options.map((option) => {
                    if (option.visible === false) return null;
                    return (
                        <MenuOption
                            Icon={option.Icon}
                            disabled={option.disabled}
                            id={option.id}
                            key={option.to}
                            listItemClassName={option.className}
                            onClick={onClick}
                            requiredPermissions={option.permission}
                            selected={option.selected || option.to === pathname}
                            title={option.label}
                            to={option.to}
                            upgradeIcon={option.upgradeIcon}
                        />
                    );
                })}
            </StyledList>
        </CheckAccess>
    );
};

SubMenuOptions.propTypes = {
    handleClose: PropTypes.func,
    options: PropTypes.array,
    title: PropTypes.string,
};

export default SubMenuOptions;
